// src/pages/AboutUsPage/AboutUsPage.tsx

import React from "react";

const AboutUsPage: React.FC = () => {
  return (
    <div>
      <h1>About Us Page</h1>
      {/* 你的页面内容 */}
    </div>
  );
};

export default AboutUsPage;
